import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=9d990f00&scoped=true&"
import script from "./GenericList.vue?vue&type=script&lang=ts&"
export * from "./GenericList.vue?vue&type=script&lang=ts&"
import style0 from "./GenericList.vue?vue&type=style&index=0&id=9d990f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d990f00",
  null
  
)

export default component.exports